import {
  fetchShoplineBrandSalesAmount,
  fetchShoplineBrandSalesOrders,
  fetchShoplineBrandSkuStatistics,
  fetchShoplineBrandECSkuStatistics,
  getStatistics,
} from 'api';

export const fetchShoplineDailyStatistics = async (
  brandId: number,
  startDate: string,
  endDate: string
) => {
  const results = await Promise.all([
    fetchShoplineBrandSalesAmount(brandId, startDate, endDate),
    fetchShoplineBrandSalesOrders(brandId, startDate, endDate),
    fetchShoplineBrandSkuStatistics(brandId, startDate, endDate),
  ]);

  return getStatistics(
    [results[0].data, results[1].data, results[2].data],
    startDate,
    endDate
  );
};

export const fetchShoplineDailyECStatistics = async (
  brandId: number,
  startDate: string,
  endDate: string
) => {
  const results = await Promise.all([
    fetchShoplineBrandSalesAmount(brandId, startDate, endDate),
    fetchShoplineBrandSalesOrders(brandId, startDate, endDate),
    fetchShoplineBrandECSkuStatistics(brandId, startDate, endDate),
  ]);

  return getStatistics(
    [results[0].data, results[1].data, results[2].data],
    startDate,
    endDate
  );
};
